@if (isLoading) {
  <mat-spinner strokeWidth="4"></mat-spinner>
}
@if (!isLoading) {
  <div class="container">
    @if ((sites | search: searchText).length==0) {
      <label>{{'no_site' | transloco}}</label>
    }
    @for (site of (sites | filters | search : searchText:true: 'name'); track site) {
      <site-card [siteId]="site.id"></site-card>
    }
  </div>
}
